export default "/assets/images/baby.png?4444bc23d21062143b2fd765ab01d776";